import { motion } from "framer-motion";
import { Star } from "lucide-react";

const HERO_IMG = "https://images.unsplash.com/photo-1633681926022-84c23e8cb2d6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHw0fHxlbGVnYW50JTIwbW9kZXJuJTIwaGFpciUyMHNhbG9uJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzgzNTk1MDc4fDA&ixlib=rb-4.1.0&q=85";

export const Hero = () => (
  <section id="top" className="bg-[#F5EDE3] pt-28 pb-16 lg:pt-36 lg:pb-24">
    <div className="max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-2 gap-12 items-center">
      <div>
        <motion.h1 initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}
          className="font-serif-brand text-4xl sm:text-5xl lg:text-6xl text-[#1C1C1C] font-semibold tracking-tight leading-[1.08]">
          Elevate Your Style.<br />Master Your Craft.
        </motion.h1>
        <motion.p initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.1 }}
          className="text-[#5C6A63] text-base md:text-lg max-w-md mt-6 font-light leading-relaxed">
          Experience premium hair, skin &amp; bridal services from our expert stylists — and train at Sonipat's leading salon academy.
        </motion.p>
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.2 }}
          className="flex flex-wrap gap-4 mt-9">
          <a href="#book" data-testid="hero-book-btn"
            className="btn-lift bg-[#0A3F2F] text-white font-semibold px-8 py-3.5 rounded-full text-sm uppercase tracking-wide hover:bg-[#0d5540]">
            Book a Service
          </a>
          <a href="#academy" data-testid="hero-academy-btn"
            className="btn-lift border-2 border-[#0A3F2F] text-[#0A3F2F] font-semibold px-8 py-3.5 rounded-full text-sm uppercase tracking-wide hover:bg-[#0A3F2F]/5">
            Explore Academy
          </a>
        </motion.div>
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.7, delay: 0.35 }}
          className="flex items-center gap-2 mt-8 text-sm text-[#5C6A63]" data-testid="hero-rating">
          <span className="flex text-[#C5A059]">
            {[...Array(4)].map((_, i) => <Star key={`hero-star-${i + 1}`} className="w-4 h-4 fill-current" />)}
            <Star className="w-4 h-4 fill-current opacity-40" />
          </span>
          <span className="font-semibold text-[#1C1C1C]">4.3</span> · 266+ Google reviews · Since 2014
        </motion.div>
      </div>
      <motion.div initial={{ opacity: 0, scale: 0.97 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.8, delay: 0.15 }}>
        <img src={HERO_IMG} alt="GREEN Professionals Salon interior"
          className="w-full h-[420px] lg:h-[540px] object-cover rounded-md shadow-[0_20px_60px_rgba(10,63,47,0.15)]" />
      </motion.div>
    </div>
  </section>
);
